const podcasts = [
  {
    id: 1,
    imgUrl: "/images/media14.png",
    altText: "Alt Text",
    title: "Meditation",
    podcasts: "16.2k",
  },
  {
    id: 2,
    imgUrl: "/images/media15.png",
    altText: "Alt Text",
    title: "Startup",
    podcasts: "24.5k",
  },
  {
    id: 3,
    imgUrl: "/images/media16.png",
    altText: "Alt Text",
    title: "Business",
    podcasts: "45.7k",
  },
  {
    id: 4,
    imgUrl: "/images/media17.png",
    altText: "Alt Text",
    title: "Politics",
    podcasts: "123k",
  },
  {
    id: 5,
    imgUrl: "/images/media15.png",
    altText: "Alt Text",
    title: "Startup",
    podcasts: "24.5k",
  },
];

export function getPodcasts() {
  return podcasts;
}
